import { useEffect } from 'react';
import { X } from 'lucide-react';
import styles from './ShortcutsModal.module.css';

interface Props {
  open: boolean;
  onClose: () => void;
}

const SHORTCUTS: { keys: string[]; label: string }[] = [
  { keys: ['Ctrl', 'Enter'], label: 'Run analysis' },
  { keys: ['⌘', 'Enter'], label: 'Run analysis (mac)' },
  { keys: ['/', ''], label: 'Focus textarea' },
  { keys: ['?'], label: 'Open this dialog' },
  { keys: ['Esc'], label: 'Close dialog or menu' },
  { keys: ['T'], label: 'Toggle theme' },
];

export function ShortcutsModal({ open, onClose }: Props) {
  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e: KeyboardEvent) => { if (e.key === 'Escape') onClose(); };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  if (!open) return null;
  return (
    <div className={styles.overlay} role="dialog" aria-modal="true" aria-labelledby="shortcuts-title" onClick={onClose}>
      <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
        <div className={styles.header}>
          <h2 id="shortcuts-title" className={styles.title}>Keyboard Shortcuts</h2>
          <button type="button" className={styles.close} onClick={onClose} aria-label="Close shortcuts">
            <X size={18} strokeWidth={1.5} />
          </button>
        </div>
        <ul className={styles.list}>
          {SHORTCUTS.filter((s) => s.keys[0]).map((s) => (
            <li key={s.label} className={styles.row}>
              <span className={styles.shortcutKeys}>
                {s.keys.filter(Boolean).map((k, i) => (
                  <span key={i}>
                    {i > 0 && <span className={styles.plus}>+</span>}
                    <kbd className={styles.kbd}>{k}</kbd>
                  </span>
                ))}
              </span>
              <span className={styles.label}>{s.label}</span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
